// removed by extract-text-webpack-plugin
module.exports = {"img":"_23htN_23"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Parcels/components/ParcelsList/ParcelsListTableDesktop/components/Error/Error.css
// module id = 731
// module chunks = 0